<template>
    <div class="vue-file-upload">
      <div class="vue-file-upload__drop-area">
        <div class="vue-file-upload-label">
          <input id="file-drop-input" type="file" name="files[]" ref="files" title="" @change="handleFilesUploads()" multiple>
          <p>Upuść pliki lub kliknij</br> i wybierz z dysku</p>
        </div>
      </div>
      <div class="vue-files-list">
        <div v-for="(file, index) in filesNames" class="file-item">
          <div class="file-cover">
            <div class="file-buttons">
              <span class="box-icon" title="usuń" @click="deleteFile(file.id)">
                <svg id="Warstwa_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14"><rect fill="#e3000b" width="14" height="14"/><line style="stroke:#fff;" x1="0.59" y1="0.59" x2="13.29" y2="13.29"/><line style="stroke:#fff;" x1="13.34" y1="0.66" x2="0.66" y2="13.34"/></svg>
              </span>
            </div>
          </div>
          <div v-if="file.src" class="file-item__head" :style="{ backgroundImage: `url(${file.src})` }"></div>
          <div v-if="!file.src" class="file-item__head"></div>
          <div class="file-item__footer">
            <span>{{file.name}}</span>
            <span>{{formatBytes(file.size)}}</span>
          </div>
        </div>
      </div>
    </div>
</template>
<script>
import { setTimeout } from 'timers';

export default {

  name: 'fileUpload',
  props:{

    stepUpload:{
      type: Boolean,
      default: true
    },

    stepUploadAdd:{
      type: Boolean,
      default: false
    },

  },
  data(){

    return{

      formData: '',
      files:'',
      filesBuffer:[],
      filesNames: [],
      orderFiles: '',
      selectedFiles: [],

    }

  },
  watch:{

    stepUploadAdd(){

      if(this.stepUploadAdd && this.filesNames.length > 0){
        this.addFiles();
      }

    },

    filesNames(){
      this.$emit('count', this.filesNames.length);
    }

  },
  methods:{

    handleFilesUploads(){

      this.formData = new FormData();
      this.filesNames = [];
      this.files = this.$refs.files.files;
      let transform = Array.from(this.files);
      transform.forEach(item=>{
        this.filesBuffer.push(item);
      })

      for( var i = 0; i < this.filesBuffer.length; i++ ){

        let file = this.filesBuffer[i];
        file.tempId = Math.floor(Math.random() * 1000) + 1;
        this.formData.append('files[' + i + ']', file);

        this.listWaitingFiles(file, file.tempId)

      }

    },

    async listWaitingFiles(file, tempId){

      if(file.type == 'image/bmp' || file.type =='image/gif' || file.type =='image/jpeg' || file.type =='image/svg+xml' || file.type =='image/tiff' || file.type =='image/webp' || file.type =='image/png'){
      
        this.filesNames.push({
          id: tempId,
          name: file.name,
          type: file.type,
          size: file.size,
          src: await this.createThumbanail(file)
        })

      }else{

        this.filesNames.push({
          id: tempId,
          name: file.name,
          type: file.type,
          size: file.size,
          src: null
        })

      }

    },

    addFiles(){

      const token = localStorage.getItem('auth_token');

      this.$http.post(`product-image-files/images`, this.formData, {
      headers: {

      'Authorization': `Bearer ${token}`,
      'Content-Type': 'multipart/form-data'

      }})
      .then(response => {
        let res = response.data
        
        this.formData = '';
        this.files = '';

        this.$emit('success', res);

      })
      .catch(error => {

        console.error(error.response);
        this.$emit('error');

      })

    },

    async createThumbanail(file){

      let reader  = new FileReader();

      return new Promise(resolve =>{
           
        reader.onload = ev =>{

          resolve(ev.target.result)

        }

        reader.readAsDataURL(file);

      });

    },

    formatBytes(bytes, decimals = 2) {

      if (bytes === 0) return '0 B';

      const k = 1024;
      const dm = decimals < 0 ? 0 : decimals;
      const sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

      const i = Math.floor(Math.log(bytes) / Math.log(k));

      return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];

    },

    deleteFile(id){

      this.filesBuffer = this.filesBuffer.filter(o => o.tempId !== id);
      this.formData = new FormData();
      this.filesNames = [];

      for( var i = 0; i < this.filesBuffer.length; i++ ){

        let file = this.filesBuffer[i];
        file.tempId = Math.floor(Math.random() * 1000) + 1;
        this.formData.append('files[' + i + ']', file);

        this.listWaitingFiles(file, file.tempId)

      }

    },

  },

}

</script>
<style lang="scss" scoped>

.vue-file-upload{
  display:flex;
  position:relative;
  flex-direction: column;
  width:100%;

  &__drop-area{
    display:flex;
    position:relative;
    justify-content: center;
    align-items: center;
    border: 1px dashed #d3dfef;
    background-color: #f8f8f8;
    z-index: 3;

    & input{
      position: absolute;
      margin: 0;
      padding: 0;
      width: 100%;
      height: 100%;
      outline: none;
      opacity: 0;
      z-index: 4;
    }
  }
}

.vue-file-upload-label{
  position:relative;
  display:flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding:20px;
  width:100%;
  height:100%;

  & p{
    font-size: 12px;
    text-align: center;
    margin:5px;
    color: #354052
  }
}

.upload-icon{
  display:flex;
  justify-content: center;
  align-items: center;
  width:50px;
  height:50px;
  border-radius: 25px;
  background: #ff3366;
  box-shadow: 0px 0px 8px 0px #d1d1d1;
  cursor:pointer;
  margin:10px 0px;

  & i{
    font-size: 24px;
    color:#fff;
  }
}

.vue-files-list{
  display:flex;
  width:100%;
  flex-wrap: wrap;
  max-height: 170px;
  overflow: hidden;
  overflow-y: auto;
  margin-top: 20px;
}

.file-item{
  position: relative;
  width:77px;
  height:77px;
  overflow: hidden;
  cursor: default;
  margin:4px 4px;

  &.selected{
    z-index: 2;
    background:rgb(233, 233, 233);
  }

  & .file-cover{
    position:absolute;
    width:100%;
    height:100%;
    top:0;
    left:0;
    z-index: 1;
  }

  &:hover .file-buttons{
    display:flex;
  }

  &__head{
    display:flex;
    justify-content: center;
    align-items: center;
    width:100%;
    height:100%;
    background-size: cover;
    background-position: center;
    background-image: url('../../../assets/symbols/no-thumbanail.png');

    .file-thumbanail{
      display: block;
      width:100%;
      height: 100%;
    }

    .box-icon{
      overflow: hidden;
      cursor: pointer;
    }
  }

  &__footer{
    display:flex;
    flex-direction: column;
    position: absolute;
    bottom:0;
    left:0;
    width:100%;
    word-break: break-word;
    overflow: hidden;
    text-align: left;
    background: rgba(0, 0, 0, 0.74);
    padding: 2px;

    span{
      font-size: 10px;
      color: #fff;
      max-height: 15px;
      white-space: nowrap;
    }
  }
}

.file-buttons{
  display:flex;
  width:100%;
  justify-content: flex-end;

  & span{
    width: 12px;
    height: 12px;

    svg {
        height: 12px; 
        width: 12px;
        position: absolute;
        top: 0px;
        right: 0;
      }
  }
}

</style>